import { Fragment, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { PAGE_PATHS, colors } from '../constants';
import { useTranslation } from 'react-i18next';
import { useReduxActions } from 'hooks/useReduxActions';
import { useSelector } from 'react-redux';
import { userSelector } from 'store/selectors';
import Text from './styled/Text';
import DropDown from './DropDown';
import Avatar from './Avatar';

const StyledHeader = styled.div`
  width: 100%;
  height: 64px;
  box-shadow: 0px -1px 0px 0px ${colors.grey95} inset;
  background-color: ${colors.white};
  padding: 16px 40px 16px 152px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;

const StyledUserContainer = styled.div`
  cursor: pointer;
  display: flex;
  gap: 6px;
`;

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const actions = useReduxActions();
  const user = useSelector(userSelector);
  const [isDropDownShow, setIsDropDownShow] = useState(false);

  const handleLogout = () => {
    setIsDropDownShow(false);
    actions.logOut();
    navigate(PAGE_PATHS.LOGIN);
  };

  const handleRedirectToProfile = () => {
    navigate(
      `${PAGE_PATHS.CLIENTS}/${user._id}/${PAGE_PATHS.CLIENT_PROFILE.PROFILE}`,
    );
  };

  const handleRoleClick = () => {
    setIsDropDownShow(!isDropDownShow);
  };

  const handleClose = () => {
    setIsDropDownShow(false);
  };

  const dropDownItems = [
    {
      text: t('header.profile.button'),
      color: colors.navy,
      onClick: handleRedirectToProfile,
    },
    {
      text: t('header.logout.button'),
      color: colors.navy,
      onClick: handleLogout,
    },
  ];

  if (
    [
      PAGE_PATHS.LOGIN,
      PAGE_PATHS.SETUP,
      PAGE_PATHS.RESET_PASSWORD,
      PAGE_PATHS.REGISTER,
      PAGE_PATHS.VERIFY_USER,
      PAGE_PATHS.PRINT_LABEL,
    ].includes(location.pathname)
  ) {
    return <Fragment />;
  }

  return (
    <StyledHeader className="header-component">
      <StyledUserContainer onClick={handleRoleClick}>
        <Avatar image={user.profile?.avatar?.url} size="large" />
        <DropDown
          onOutsideClick={handleClose}
          show={isDropDownShow}
          items={dropDownItems}>
          <Text variant="body">{user.role}</Text>
        </DropDown>
      </StyledUserContainer>
    </StyledHeader>
  );
};

export default Header;
